<template>
    <!-- <section class="rules-card px-0" loading="lazy">
        <div class="rules-card-header">
            <h1>{{$t('rules', 'Rules')}}</h1>
        </div>
        <div class="container-fluid px-2">
            <div class="rules-card-body">
                <div>
                    <template v-for="(rule, r_index, rule_num) in siteRuleData" :key="r_index">
                        <template v-if="r_index == 'General'">                            
                            <div class="menu-details-list all-rule" v-html="rule"></div>
                        </template>
                    </template>
                </div>
            </div>
        </div>
    </section> -->
<div class="exposure">
    <div class="modal fade mymarket-modal-box rulemodal-detail" id="rulemodal" tabindex="-1" aria-labelledby="rulemodalLabel" aria-hidden="true">
         <div class="modal-dialog modal-lg">
            <div class="modal-content">
               <div class="modal-header">
                  <h5 class="modal-title">
					{{$t('rules', 'Rules')}}
                  </h5>
                  <button type="button" class="btn-close my-market-close-btn" data-bs-dismiss="modal" aria-label="Close"
                     ref="closeMyMarket">
                  </button>
               </div>
               <div class="modal-body">
				    <template v-for="(rule, r_index, rule_num) in siteRuleData" :key="r_index">
                        <template v-if="r_index == 'General'">                            
                            <div class="menu-details-list all-rule" v-html="rule"></div>
                        </template>
                    </template>
               </div>
               <div class="rules-modal-footer">
                    <button class="btn btn-danger" data-bs-dismiss="modal" aria-label="Close">{{$t('close', 'Close')}}</button>
               </div>
            </div>
        </div>
    </div>
</div>
    <!-- Back to top button -->
    <div class="scroll-move-to-top-btn">
        <div class="contentDiv" id="content">
            <button class="back-to-top" :class="{show: scrollHeight}" type="button" @click="scrollToTop()"></button>
        </div>
    </div>

</template>

<script>
export default {
    name: 'Rules',
    props:['siteRuleData'],
    mounted(){ 
        window.addEventListener('scroll', this.handleScroll);
    },
    methods:{
        scrollToTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        },
        handleScroll() {
            this.scrollHeight = window.scrollY > 200;
        },
    }
}
</script>